import type { TextBlock } from '@/types/pageContentTypes';

export type MaybeTextBlock =
  TextBlock | Partial<TextBlock> | string | null | undefined;

export const normalizeRichText = (
  value?: MaybeTextBlock,
): TextBlock | undefined => {
  if (!value) {
    return undefined;
  }

  if (typeof value === 'string') {
    return {
      content: value,
    };
  }

  if (!value.content) {
    return undefined;
  }

  return {
    content: value.content,
    styles: value.styles,
  };
};
